import { Component, computed, inject, OnInit, signal } from "@angular/core";
import { Router } from "@angular/router";
import { BroadcastService } from "@bbwt/modules/broadcasting";
import { GlobalDroService } from "@project/prescription/classes/globaldro-service";
import { PrimeNgModule } from "@primeng";
import { UserService } from "@main/users";
import { CommonModule } from "@angular/common";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { OfflineModule } from "@main/offline/offline.module";

@Component({
    selector: "globaldro-terms",
    standalone: true,
    templateUrl: "./globaldro-terms.component.html",
    styleUrls: ["./globaldro-terms.component.scss"],
    imports: [
        PrimeNgModule,
        CommonModule,
        OfflineModule
    ],
})
export class GlobalDroTermsComponent {
    private broadcastService = inject(BroadcastService);
    private userService = inject(UserService);
    private router = inject(Router);

    showDialog = signal(false);
    isProcessing = signal(false);
    declineAttempts = signal(0);

    showDeclineWarning = computed(() => this.declineAttempts() > 0);
    declineButtonLabel = computed(() => this.declineAttempts() > 0 ? "Go to Homepage" : "Decline");

    private attemptedUrl: string = "/";

    constructor() {
        this.subscribeEvents();
    }

    private subscribeEvents(): void {
        this.broadcastService
            .on<string>(GlobalDroService.RequiredGlobalDroTermsEventName)
            .pipe(takeUntilDestroyed())
            .subscribe((url: string) => {
                this.attemptedUrl = url || "/";
                this.showDialog.set(true);
                this.declineAttempts.set(0);
            });
    }

    async onAccept(): Promise<void> {
        if (this.isProcessing()) return;

        this.isProcessing.set(true);

        try {
            await this.userService.updateGlobalDroTermsAccepted(true);
            await this.userService.refreshCurrentUser();
            this.showDialog.set(false);

            this.declineAttempts.set(0);
            await this.router.navigateByUrl(this.attemptedUrl);
        } finally {
            this.isProcessing.set(false);
        }
    }

    onDecline(): void {
        this.declineAttempts.update(value => value + 1);

        if (this.declineAttempts() > 1) {
            this.showDialog.set(false);
            this.declineAttempts.set(0);
            this.router.navigate(["/app"]);
        }
    }
}